export default "__VITE_ASSET__BisLL89q__"